import {
  takeEvery,
  takeLatest,
  put,
  call
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../../axios-api';

import formListActions from './actions';
import formListConstants from './constants';

import formEditorActions from '../FormEditor/actions';

const mapFormsResponse = (response) => {
  const forms = response.data.docs;

  const formsDTO = _.map(forms, form => ({
    id: form.id,
    status: form.status,
    privacy: form.privacy,
    title: form.JSONSchema.title,
    description: form.JSONSchema.description,
    link: form.link
  }));

  return formsDTO;
};

export function* formListInit(action) {
  try {
    const {
      token
    } = action.payload;
  
    const apiClient = axios(token);
    const response = yield call(apiClient.get, '/form');

    const forms = mapFormsResponse(response);

    yield put(formListActions.formListInitSuccess(forms));
    yield put(formEditorActions.formUnload());
  }
  catch {
    yield put(formListActions.formListInitError());
  }
}

export function* createForm(action) {
  try {
    const {
      token
    } = action.payload;
  
    const apiClient = axios(token);
    const response = yield call(apiClient.post, '/form', {});
    const {
      id
    } = response.data;

    yield put(formListActions.createFormSuccess(id));
  }
  catch (error) {
    yield put(formListActions.createFormError);
  }
}

export default function* FormListSage() {
  yield takeEvery(formListConstants.INITIALIZE_FORM_LIST, formListInit);
  yield takeLatest(formListConstants.CREATE_FORM, createForm);
}
